export const resetOrderSession = () => {
    localStorage.removeItem('orderart_session_id');
    localStorage.removeItem('order_id');
    localStorage.removeItem('orderType');
  };